// Typelizer digest 6025816f20f6cd25a0484bdd3f85f097
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /account/cancel */
  cancel: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/account/cancel', {}, options),
    method: 'get',
  }),

  /** GET /account/sign_up */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/account/sign_up', {}, options),
    method: 'get',
  }),

  /** GET /account/edit */
  edit: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/account/edit', {}, options),
    method: 'get',
  }),

  /** PATCH /account */
  update: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/account', {}, options),
    method: 'patch',
  }),

  /** DELETE /account */
  destroy: (options?: RouteOptions): RouteDefinition<'delete'> => ({
    url: buildUrl('/account', {}, options),
    method: 'delete',
  }),

  /** POST /account */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/account', {}, options),
    method: 'post',
  }),
}
